import React, { useEffect, useState } from 'react';
// import './LandingPage.css';
import pagesService from '../../services/pages';
import LoadingSpinner from '../../components/loader/LoadingSpinner';

const LandingPage = () => {

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  useEffect(() => {

    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch all data in parallel
        const response = await pagesService.getBySlug(`advanced-ivf`)

        if (response?.data) {

          setData(response?.data);
          setLoading(false);
        }else{
          setLoading(false)
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();

  }, []);

  console.log('ivf data rrr', data)

  return (
    <>
    {loading && <LoadingSpinner />}
    <div className="advanced-ivf-page">
      <div className="advanced-ivf-banner">
        <div className="advanced-ivf-banner-overlay"></div>
        <img
          src={data?.images?.[0]?.url}
          alt="Banner"
          className="advanced-ivf-banner-image"
        />
        <h1 className="advanced-ivf-banner-text">
          {data?.title}
        </h1>
      </div>
      <div dangerouslySetInnerHTML={{ __html: data?.description }}></div>
    </div>
    </>
  );
};

export default LandingPage;